import React from "react";

const NotFound = () => {
  return (
    <h1 className='sm:text-4xl text-2xl font-bold my-6 text-gray-900'>
      404: Page not found
    </h1>
  );
};

export default NotFound;